import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { applyListParams } from "../_shared";
import {
  currentUserId,
  decorateJob,
  jobsListSortMap,
  jobsSearchCols,
} from "./_helpers";

// caller's currently-claimed jobs (claim status = 'active'), regardless of job status.
// v_jobs_list only joins active claims, so filtering on claim_user_id is sufficient.
function myJobsBase(sb: Ctx["sb"], userId: string) {
  return sb.from("v_jobs_list").select("*").eq("claim_user_id", userId);
}

export const my_jobs: Query<Ctx> = async ({ sb }, params) => {
  const userId = await currentUserId(sb);
  if (!userId) return [];
  const base = myJobsBase(sb, userId);

  const query = applyListParams(base, params, {
    search: jobsSearchCols,
    sort: {
      map: jobsListSortMap,
      default: [
        { column: "start_date", ascending: false },
        { column: "start_time", ascending: false },
      ],
    },
  });
  const { data } = await query;
  if (!data) return [];
  return data.map(decorateJob);
};

// upcoming = end_date today or later (future or in-progress)
export const my_upcoming_jobs: Query<Ctx> = async ({ sb }, params) => {
  const userId = await currentUserId(sb);
  if (!userId) return [];
  const base = myJobsBase(sb, userId);
  const today = new Date().toISOString().slice(0, 10);

  const query = applyListParams(base.gte("end_date", today), params, {
    search: jobsSearchCols,
    sort: {
      map: jobsListSortMap,
      default: [
        { column: "start_date", ascending: false },
        { column: "start_time", ascending: false },
      ],
    },
  });
  const { data } = await query;
  if (!data) return [];
  return data.map(decorateJob);
};

// past = end_date strictly before today
export const my_past_jobs: Query<Ctx> = async ({ sb }, params) => {
  const userId = await currentUserId(sb);
  if (!userId) return [];
  const base = myJobsBase(sb, userId);
  const today = new Date().toISOString().slice(0, 10);

  const query = applyListParams(base.lt("end_date", today), params, {
    search: jobsSearchCols,
    sort: {
      map: jobsListSortMap,
      default: [
        { column: "end_date", ascending: false },
        { column: "start_time", ascending: false },
      ],
    },
  });
  const { data } = await query;
  if (!data) return [];
  return data.map(decorateJob);
};
